import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import ReactHtmlParser from 'react-html-parser';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './SavePublishEvent.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class SavePublishEvent extends Component {

    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isSavePublishEventOpen} toggle={this.props.toggleSavePublishEvent}>
		          	<ModalHeader toggle={this.props.toggleSavePublishEvent}>{strings.title}</ModalHeader>
		          	<ModalBody>
		            	{ReactHtmlParser(strings.description)}
		          	</ModalBody>
		          	<ModalFooter className="text-center">
					  	<button 
							type="submit" 
							className="showtix-button showtix-background__grey-1"
							onClick={this.props.saveDraftEvent}
							>{strings.draftButton}</button>
		            	<button 
		            		type="submit" 
		            		className="showtix-button showtix-background__primary-3"
                            onClick={this.props.savePublishEvent}
		            		>{strings.saveButton}</button>
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

SavePublishEvent.propTypes = {
    isSavePublishEventOpen: PropTypes.bool,
    toggleSavePublishEvent: PropTypes.func,
    saveDraftEvent: PropTypes.func,
    savePublishEvent: PropTypes.func
}

export default SavePublishEvent;


// WEBPACK FOOTER //
// ./src/components/SavePublishEvent/SavePublishEvent.js